<template>
  <div class="filter-tabs">
    <template v-if="tabs && tabs.length > 0">
      <div
        class="tab-item"
        v-for="(tab, index) in tabs"
        :key="tab.key"
        :class="{ active: activeTab && tab.key === activeTab.key }"
        @click="handleActiveChange(index, tab)"
      >
        <text-box
          :mode="mode"
          :includeBtns="['confirm', 'edit', 'delete', 'add']"
          :value="tab.label"
          @onAdd="handleTabAdd(index)"
          @onDelete="handleTabDelete(index)"
          @onChange="value => handleTabLabelChange(index, value)"
        >
          {{ tab.label || "标签页" }}
        </text-box>
      </div>
    </template>
    <template v-else-if="mode === 'edit'">
      <button class="add-btn" @click.stop="handleTabAdd(0)">
        <i class="icon wiki-editable-add"></i>
      </button>
    </template>
  </div>
</template>

<script>
// components
import TextBox from "../TextBox";
export default {
  name: "filter-tabs",
  components: {
    TextBox
  },
  props: {
    mode: String,
    activeTab: {
      type: Object,
      default: () => ({})
    },
    tabs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {
    handleActiveChange(index, tab) {
      this.$emit("onActive", index, tab);
    },
    handleTabLabelChange(index, value) {
      const tabs = this.tabs;
      const currentTab = tabs[index];
      currentTab.label = value;
      this.$emit("onChange", index, currentTab);
    },
    handleTabAdd(index) {
      this.$emit("onAdd", index);
    },
    handleTabDelete(index) {
      this.$emit("onDelete", index);
    }
  }
};
</script>

<style lang="less" scoped>
.filter-tabs {
  width: 100%;
  min-height: 32px;
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid #e3e3e3;
  gap: 10px;
  .tab-item {
    cursor: pointer;
    width: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 16px;
    color: rgba(105, 113, 136, 0.77);
    &.active {
      font-weight: 600;
      border-bottom: 2px solid rgba(105, 113, 136, 0.77);
    }
    &:hover {
      font-weight: 600;
    }
  }
}

.add-btn {
  width: 20px;
  height: 20px;
  color: #ffffff;
  border-radius: 4px;
  margin-left: 3px;
  border: none;
  vertical-align: middle;
  line-height: 20px;
  text-align: center;
  &:hover {
    opacity: 0.9;
  }
  .icon {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
}
</style>
